import { createFileRoute } from "@tanstack/react-router";
import { SinceCalculator } from "@/components/tools/SinceCalculator";

export const Route = createFileRoute("/tools/hari-jadian")({
  head: () => ({
    meta: [
      { title: "Kalkulator Hari Jadian - Sudah Berapa Lama Pacaran?" },
      { name: "description", content: "Hitung sudah berapa lama kamu jadian dengan dia. Hasil tahun, bulan, hari, weton tanggal jadian, dan link bagikan." },
      { property: "og:title", content: "Kalkulator Hari Jadian" },
      { property: "og:description", content: "Sudah berapa lama jadian sama dia? Cek di sini." },
    ],
  }),
  component: () => (
    <SinceCalculator
      title="Kalkulator Hari Jadian"
      intro="Sudah berapa lama kamu jadian dengan dia? Masukkan tanggal jadian untuk lihat total hari, bulan, dan tahun yang sudah dilalui bersama."
      dateLabel="Tanggal jadian"
      verb="jadian"
      iconKey="since-heart"
      storageKey="jadian"
      path="/tools/hari-jadian"
      body={[
        { heading: "Apa itu kalkulator hari jadian?", text: "Kalkulator hari jadian membantu kamu menghitung berapa lama hubungan kamu sudah berjalan, dihitung dari tanggal pertama kali resmi jadian. Cocok untuk merayakan monthsary, anniversary, atau sekadar ngecek umur hubungan." },
        { heading: "Cara menghitungnya", text: "Selisih hari dihitung dari tanggal jadian sampai hari ini. Kami juga pecah jadi tahun-bulan-hari, total minggu, jam, dan menit, plus weton hari itu menurut kalender Jawa." },
        { heading: "Tips momen anniversary", text: "Kalkulator ini bisa dipakai sebagai pengingat tanggal-tanggal penting: 100 hari, 1 tahun, 1000 hari. Bagikan link hasilnya ke pasangan supaya kalian sama-sama tahu." },
      ]}
      faq={[
        { q: "Apakah hasil kalkulator ini akurat?", a: "Ya, hasil dihitung tepat sampai per hari menggunakan kalender Masehi. Ini bukan estimasi." },
        { q: "Apakah saya bisa menyimpan tanggal jadian?", a: "Tanggal yang kamu masukkan otomatis tersimpan di browser kamu, jadi saat kembali tidak perlu input ulang." },
        { q: "Bisakah dibagikan ke pasangan?", a: "Bisa. Klik tombol Bagikan hasil untuk menyalin link yang berisi tanggal jadian." },
        { q: "Bagaimana jika saya lupa tanggal pasti?", a: "Pilih perkiraan terbaik. Hasilnya tetap memberi gambaran yang masuk akal soal lamanya hubungan." },
        { q: "Apa beda dengan kalkulator hari biasa?", a: "Kalkulator ini fokus menghitung waktu sejak satu titik (tanggal jadian) sampai sekarang. Kalau kamu butuh selisih dua tanggal manual, pakai Kalkulator Hari." },
      ]}
    />
  ),
});